/* eslint-disable @typescript-eslint/naming-convention, camelcase */
import {
    getHotlineNumbers,
    getPageLevels,
    normalizeTrackingPayloadPrice,
    TrackingBasePayload,
    TrackingDslBtx,
    TrackingErrorType,
    TrackingFixnetFlowType,
    TrackingFixnetProductLine,
    TrackingItemType,
    TrackingLoginStatus,
    TrackingOrderObject,
    TrackingOrderProduct,
    TrackingPageType,
    TrackingPlatformType,
    TrackingRetention,
    TrackingSiteArea,
    TrackingTargetAudience,
} from '@vfde-sails/tracking';
import { AppState } from '../container/App/interface';
import { JarvisPriceType } from '@vfde-sails/availability';
import { ErrorType } from '../container/App/enum';

/**
 * Creates the base PageView tracking event
 */
export const getTrackingBase = ({ customer }: AppState): TrackingBasePayload => ({
    login_status: customer
        ? TrackingLoginStatus.LoggedIn
        : TrackingLoginStatus.NotLoggedIn,
    page_type: TrackingPageType.ProductDetail,
    site_area: TrackingSiteArea.DSL,
    platform_type: TrackingPlatformType.Responsive,
    business_transaction_type: TrackingDslBtx.DslInternetPhone,
    line_of_customer: TrackingTargetAudience.Consumer,
    flow_type: TrackingFixnetFlowType.InternetPhone,
    page_levels: getPageLevels(),
    hotline_numbers: getHotlineNumbers(),
});

const getTrackingPriceKey = (type: JarvisPriceType) => type === JarvisPriceType.Once
    ? 'price_once'
    : 'price_monthly';

/**
 * Creates the oOrder object for the PageView tracking event
 */
export const getTrackingOrderObject = ({ customer, selectedTariffId, tariffs }: AppState): TrackingOrderObject => {
    const selectedTariff = tariffs?.[selectedTariffId];

    if (!selectedTariff) {
        return { aProducts: [], aPropositions: [] };
    }

    const { zipcode } = customer?.cableContract?.address ?? {};
    const { id, price, duration } = selectedTariff;

    return {
        aPropositions: [{
            id: 1,
            name: id,
            target_audience: TrackingTargetAudience.Consumer,
            retention: TrackingRetention.NewContract,
            product_type: TrackingItemType.Tariff,
            product_line: TrackingFixnetProductLine.InternetPhone,
            product_category: TrackingItemType.Tariff,
            units: 1,
        }],
        aProducts: [{
            sku: id,
            name: id,
            type: TrackingItemType.Tariff,
            proposition: 1,
            units: 1,
            [getTrackingPriceKey(price.type)]: normalizeTrackingPayloadPrice(price.value),
            duration,
        } as TrackingOrderProduct], // Note: Wrong interface in library (TrackingProduct instead of TrackingOrderProduct) -> Fix
        ...zipcode && { zipcode },
    };
};
